export function _share(link) {
  return function() {
    if(navigator.share && navigator.canShare({url : link})) {
      navigator.share({url : link});
    } else {
      navigator.clipboard.writeText(link);
    }
  }
}